export function topfixfunc(){
    var main=document.querySelector('.el-main')
    let width=main.offsetWidth
    // document.style.overflowX='none'
    // 获取固定栏
    var topFix=document.querySelector('.topFix')
    var topContainer=document.querySelector('.topContainer')
    // topFix.style.paddingLeft='560px'
    // 获取隐藏栏
    // 固定栏隐藏
    // 节流
    // flag
    main.addEventListener('scroll', (e)=> {
  　　var scrollTop = e.srcElement.pageYOffset || e.srcElement.scrollTop || e.srcElement.scrollTop;
      // 固定栏显示
      if(scrollTop>70){
        // 显示元素
        // 绝对定位
        topFix.style.position='fixed'
        topContainer.style.height='56px'
        // 顶部位置
        topFix.style.top='69px'
        topFix.style.zIndex='999'
        topFix.style.transform='translateX(-'+60+'px)'
        topFix.style.backgroundColor='#D3DCE6'
        topFix.style.width=width+'px'
        topFix.style.paddingBottom='10px'
        topFix.style.paddingTop='10px'
        topFix.style.paddingLeft='60px'
      }else{
        // 绝对定位
        topContainer.style.height='56px'
        topFix.style.position='static'
        // 顶部位置
        topFix.style.zIndex='999'
        topFix.style.transform='translateX(-'+60+'px)'
        topFix.style.backgroundColor='#E9EEF3'
        topFix.style.width='100vw'
        topFix.style.paddingTop='0px'
        topFix.style.paddingBottom='10px'
        topFix.style.paddingLeft='60px'
      }
    })
}



// WEBPACK FOOTER //
// ./src/utils/topFix.js